import React from 'react';
import { LucideIcon, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LoadingPlaceholderProps {
    icon?: LucideIcon;
    title?: string;
    description?: string;
    className?: string;
    iconClassName?: string;
    showSpinner?: boolean;
}

export const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({
    icon: Icon,
    title,
    description,
    className = "",
    iconClassName = "text-gray-400",
    showSpinner = true
}) => {
    const { t } = useTranslation();

    const defaultTitle = title || t('ui.loading');
    const defaultDescription = description || t('ui.please_wait_fetching_data');
    return (
        <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
            {showSpinner && (
                <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-4">
                    <Loader2 className={`w-8 h-8 ${iconClassName} animate-spin`} />
                </div>
            )}
            {Icon && !showSpinner && (
                <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-4">
                    <Icon className={`w-8 h-8 ${iconClassName}`} />
                </div>
            )}
            <div className="text-gray-500 dark:text-gray-400 text-center">
                <div className="text-lg font-medium mb-2 dark:text-gray-300">{defaultTitle}</div>
                <div className="text-sm dark:text-gray-400">{defaultDescription}</div>
            </div>
        </div>
    );
}; 